import { createAction, createReducer } from '@reduxjs/toolkit';
import { get } from 'lodash-es';
import { NEWS_TAB_NAME } from '../../../constants/equity/newsAndAnnouncements';

const MODULE_PREFIX = '[ NEWS AND ANNOUNCMEMETS ]';

const Actions = {
	fetchPortfolioNewsData: `${MODULE_PREFIX} fetchPortfolioNewsData`,
	setPortfolioNewsData: `${MODULE_PREFIX} setPortfolioNewsData`,
	fetchAnnouncements: `${MODULE_PREFIX} fetchAnnouncements`,
	setAnnouncements: `${MODULE_PREFIX} setAnnouncements`,
	fetchNewsDetails: `${MODULE_PREFIX} fetchNewsDetails`,
	setNewsDetails: `${MODULE_PREFIX} setNewsDetails`,
	updateNewsDetails: `${MODULE_PREFIX} updateNewsDetails`,
	fetchNewsData: `${MODULE_PREFIX} fetchNewsData`,
	setNewsData: `${MODULE_PREFIX} setNewsData`,
	fetchSectorList: `${MODULE_PREFIX} fetchSectorList`,
	setSectorList: `${MODULE_PREFIX} setSectorList`,
	fetchSectorNewsData: `${MODULE_PREFIX} getSectorNewsData`,
	clearNewsDetails: `${MODULE_PREFIX} clearNewsDetails`,
	clearNewsLandingData: `${MODULE_PREFIX} clearNewsLandingData`,
	setSelectedNewsTab: `${MODULE_PREFIX} setSelectedNewsTab`,
};

//actions
export const fetchPortfolioNewsData = createAction(Actions.fetchPortfolioNewsData);
export const setPortfolioNewsData = createAction(Actions.setPortfolioNewsData);
export const fetchAnnouncements = createAction(Actions.fetchAnnouncements);
export const setAnnouncements = createAction(Actions.setAnnouncements);
export const fetchNewsDetails = createAction(Actions.fetchNewsDetails);
export const setNewsDetails = createAction(Actions.setNewsDetails);
export const updateNewsDetails = createAction(Actions.updateNewsDetails);
export const clearNewsDetails = createAction(Actions.clearNewsDetails);
export const clearNewsLandingData = createAction(Actions.clearNewsLandingData);
export const fetchNewsData = createAction(Actions.fetchNewsData);
export const setNewsData = createAction(Actions.setNewsData);
export const fetchSectorList = createAction(Actions.fetchSectorList);
export const setSectorList = createAction(Actions.setSectorList);
export const fetchSectorNewsData = createAction(Actions.fetchSectorNewsData);
export const setSelectedNewsTab = createAction(Actions.setSelectedNewsTab);

//Selectors
export const getPortfolioNewsData = (state) => get(state, 'newsAndAnnouncements.portfolioNewsData', {});
export const getLandingError = (state) => get(state, 'newsAndAnnouncements.error', {});
export const getAnnouncements = (state) => get(state, 'newsAndAnnouncements.announcements', {});
export const getNewsDetail = (state) => get(state, 'newsAndAnnouncements.selectedNewsDetails', {});
export const getNewsData = (state) => get(state, 'newsAndAnnouncements.news', {});
export const getSectorList = (state) => get(state, 'newsAndAnnouncements.sectorList', {});
export const getSelectedNewsTab = (state) => get(state, 'newsAndAnnouncements.selectedNewsTab', '');

//initial state
const initialNewsState = {
	data: [],
	isLoading: true,
	isFetchFailed: false,
	error: null,
};

const initialState = {
	isLoading: false,
	error: {},
	announcements: initialNewsState,
	sectorList: initialNewsState,
	news: initialNewsState,
	portfolioNewsData: initialNewsState,
	selectedNewsDetails: {},
	selectedNewsTab: NEWS_TAB_NAME.HOT_PURSUIT,
};

//reducer
export default createReducer(initialState, (builder) => {
	builder.addCase(setSectorList, (state, { payload }) => {
		state.sectorList = { ...state.sectorList, ...payload };
	});
	builder.addCase(setNewsData, (state, { payload }) => {
		state.news = { ...state.news, ...payload };
	});
	builder.addCase(setPortfolioNewsData, (state, { payload }) => {
		state.portfolioNewsData = { ...state.portfolioNewsData, ...payload };
	});
	builder.addCase(setAnnouncements, (state, { payload }) => {
		state.announcements = { ...state.announcements, ...payload };
	});
	builder.addCase(setNewsDetails, (state, { payload }) => {
		state.selectedNewsDetails = payload;
	});
	builder.addCase(updateNewsDetails, (state, { payload }) => {
		state.selectedNewsDetails = { ...state.selectedNewsDetails, ...payload };
	});
	builder.addCase(clearNewsDetails, (state) => {
		state.selectedNewsDetails = {};
	});
	builder.addCase(clearNewsLandingData, (state) => {
		state.hotPursuit = initialNewsState;
		state.announcements = initialNewsState;
		state.news = initialNewsState;
		state.sectorList = initialNewsState;
	});
	builder.addCase(setSelectedNewsTab, (state, action) => {
		state.selectedNewsTab = action.payload;
	});
});
